module.exports = __webpack_public_path__ + "static/media/intro.0bc798dd.mp3";